import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()
export class RelatorioSpnvService extends ServiceCRUD {
  private baseUrlService: string;

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService
  ) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/relatorio_spnv`;
  }

  public getResumo(
    data_inicial: string,
    data_final: string,
    userDealerIds: string,
    dealer?: string
  ): Observable<{ dealers: any[] }> {
    let params = new HttpParams()
      .set('data_inicial', data_inicial)
      .set('data_final', data_final);

    if (dealer) {
      params = params.set('dealer', dealer);
    }

    return this.httpClient.get<{ dealers: any[] }>(
      `${this.baseUrlService}/relatorio_spnv`,
      {
        headers: this.buildHeaders(),
        params,
      }
    );
  }

  public getChassis(
    data_inicial: string,
    data_final: string,
    dealer: string,
    _userDealerIds?: string
  ): Observable<{ chassis: any[] }> {
    const params = new HttpParams()
      .set('data_inicial', data_inicial)
      .set('data_final', data_final)
      .set('dealer', dealer);

    return this.httpClient.get<{ chassis: any[] }>(
      `${this.baseUrlService}/relatorio_spnv/chassis`,
      {
        headers: this.buildHeaders(),
        params,
      }
    );
  }

  private buildHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token,
    });
  }
}
